import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=23b874ed"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b874ed')) {
      api.createRecord('23b874ed', component.options)
    } else {
      api.reload('23b874ed', component.options)
    }
    module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=23b874ed", function () {
      api.rerender('23b874ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingSpinner.vue"
export default component.exports